import { useMutation, useQueryClient } from '@tanstack/react-query';
import { purchaseRequisitionService } from '@/services/purchaseRequisitionService';
import type { PurchaseRequisitionRequest } from '@/services/purchaseRequisitionService';
import { useNotifications } from '@/stores/useNotificationStore';
import { getErrorMessage } from '@/utils/httpClient';
import { queryKeys } from '@/lib/queryKeys';

export const useCompletePurchaseRequisition = () => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  return useMutation({
    mutationFn: (request: PurchaseRequisitionRequest) =>
      purchaseRequisitionService.completePurchaseRequisition(request),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.orders.list() });
      notifications.success('Order Created', `Order ${data.orderIdentifier} created successfully`);
    },
    onError: (error: unknown) => {
      const message = getErrorMessage(error);
      notifications.error('Order Creation Failed', message);
    },
  });
};
